import { render, staticRenderFns } from "./Decidequestion.vue?vue&type=template&id=05e58f15&scoped=true"
import script from "./Decidequestion.vue?vue&type=script&lang=js"
export * from "./Decidequestion.vue?vue&type=script&lang=js"
import style0 from "./Decidequestion.vue?vue&type=style&index=0&id=05e58f15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e58f15",
  null
  
)

export default component.exports